export default function Footer() {
  return (
    <footer className="w-full bg-background-200 text-foreground-800">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-14">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-2">
            <a href="#top" className="flex items-center gap-2 whitespace-nowrap">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-broadcast-fill text-lg" />
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-xl font-black text-foreground-950">
                  大瓜预警
                </span>
                <span className="text-[10px] tracking-[0.35em] text-primary-700">
                  BIG MELON ALERT
                </span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              汇集内部消息与知情人士透露，持续更新圈内线索。每一条都标注核实状态，
              理性吃瓜，不造谣、不传谣，尊重每一位当事人。
            </p>
            <div className="mt-4 flex items-center gap-3">
              {["ri-wechat-line", "ri-weibo-line", "ri-douban-line", "ri-bilibili-line"].map(
                (ic) => (
                  <a
                    key={ic}
                    href="#top"
                    aria-label="社交平台"
                    className="flex h-9 w-9 items-center justify-center rounded-full bg-background-300 text-foreground-700 transition-colors hover:bg-primary-500 hover:text-background-50"
                  >
                    <i className={`${ic} text-lg`} />
                  </a>
                )
              )}
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">站内导航</h3>
            <ul className="mt-3 space-y-2 text-sm">
              {[
                ["最新热瓜", "#latest"],
                ["重磅关注", "#featured"],
                ["今日瓜线", "#timeline"],
                ["吃瓜FAQ", "#faq"],
              ].map(([label, href]) => (
                <li key={href}>
                  <a href={href} className="whitespace-nowrap hover:text-primary-700">
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-foreground-950">关于与联系</h3>
            <ul className="mt-3 space-y-2 text-sm">
              <li>
                <a href="#about" className="whitespace-nowrap hover:text-primary-700">
                  关于我们
                </a>
              </li>
              <li>
                <a href="#submit" className="whitespace-nowrap hover:text-primary-700">
                  匿名投稿
                </a>
              </li>
              <li>
                <a href="#submit" className="whitespace-nowrap hover:text-primary-700">
                  纠错 / 申诉
                </a>
              </li>
              <li>
                <a
                  href="mailto:hello@daguayujing.cn"
                  className="whitespace-nowrap hover:text-primary-700"
                >
                  联系编辑部
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div className="border-t border-background-300">
        <div className="mx-auto flex w-full max-w-6xl flex-col items-center justify-between gap-2 px-4 py-4 text-xs text-foreground-600 sm:flex-row md:px-6">
          <p className="whitespace-nowrap">
            © 2026 大瓜预警 BIG MELON ALERT · 部分内容源自网络线索，仅供参考，请理性看待
          </p>
          <p className="flex items-center gap-1.5 whitespace-nowrap">
            <i className="ri-shield-check-line" />
            不造谣 · 不传谣 · 尊重当事人
          </p>
        </div>
      </div>
    </footer>
  );
}